<template>
  <v-dialog
    v-model="isVisibleDialog"
    persistent
    max-width="950px"
  >
    <v-form
      ref="form"
      lazy-validation
    >
      <v-card>
        <v-card-title>
          <span class="text-h3 text-capitalize">Unassign Product Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-autocomplete
                  v-model="options.product"
                  dense
                  :items="productList"
                  item-value="id"
                  item-text="name"
                  :label="$t('select_product_*')"
                  multiple
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>{{ $t("indicates_required_field") }}</small>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="closeForm()"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading"
            @click="isUnassign = true"
          >
            Unassign
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <confirmation-modal
      v-if="isUnassign"
      :is-visible="isUnassign"
      :toggle="toggleUnassignModal"
      msg="Are you sure to Unassign"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  components:{
     ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [validationRules],

  props: {
    isVisibleDialog: Boolean,
    toggleEdit: {
      type: Function,
      default() {
        return void 0;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      tab: 0,
      loading: false,
      isUnassign:false,
      options:{
        product:[]
      }
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      productList:"products/getProductList",

    }),
  },
  async mounted() {
    this.options.product = this.item?.product_tiers.map(r=> r.product_id)
  },
  methods: {

    async toggleUnassignModal(val){
      if(val == 'ok'){
        await this.unassignItem()
        this.isUnassign= false
        this.$store.dispatch("alerts/success", this.$t("unassigned_successfully"));
      }
      else this.isUnassign = false
    },
    
    async unassignItem() {
      const params ={};
      params.id = this.item?.id
      params.product_ids = this.productList.filter(r=> !this.options.product.includes(r.id)).map(r=> r.id)
      this.loading = true;
      await this.$store.dispatch("productTiers/unassign",params).then(()=>{
        this.closeForm();
         this.$store.dispatch(
            "alerts/success",
            this.$t("unassigned_successfully")
          );
      }).catch((error) => {
          this.$store.dispatch("alerts/error", error.response?.data?.message);
          this.isLoading = false;
        }).finally(()=> this.loading = false)

    },
    closeForm() {
      this.toggleEdit();
    },
  },
};
</script>
